var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fedb4c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50,93.75A43.75,43.75,0,1,1,93.75,50,43.75,43.75,0,0,1,50,93.75ZM50,100A50,50,0,1,0,0,50,50,50,0,0,0,50,100Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7,47.776a6.25,6.25,0,1,1,6.25,6.25A6.25,6.25,0,0,1,7,47.776Zm.612-37.531a5.656,5.656,0,1,1,11.25,0L16.677,32.164a3.45,3.45,0,0,1-6.875,0Z",
    transform: "translate(36.761 20.974)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.6c293603a90c8fefa57b7520a749ea78.svg";
export { ForwardRef as ReactComponent };